/**
* Extended ViewController template
*
* User: adic
* Date: 4/21/13
* Time: 9:54 AM
*/
define(function (require) {

    var TableViewController = require('web-agent-framework/TableViewController');
    var WidgetViewController = require('web-agent-framework/WidgetViewController');

    var PageNavigationWidget = WidgetViewController.extend({
        ControllerName: 'PageNavigationWidget',
        applicationType: 'PageNavigationWidget',

        widgetIcon: "compass_navigation",// widget icon is necessary for viewing the widget in visitor list section

        LPViewMap: {
            pageNavigationTable: ".lpview_page_navigation_table",
            pageNavigationItems: ".lpview_page_items"
        },
        initialize: function (constructorData) {
            this.tableName = constructorData.tableName;
            this.pageNavigationTable = new TableViewController({
                modelController: this.modelController,
                rowTemplateFile: "LP_visitor_info_link_content.html",
                dataRenderer: this.pageNavigationDataRenderer,
                context: this
            });
            this.addViewController({viewController : this.pageNavigationTable, target : this.LPViewMap.pageNavigationItems});
        },

        events: function () {
            if (this.singleton) {
                this.viewEventsHandler.bindEvent({appName : this.tableName , UIEvent : this.viewEventsHandler.eventType.TABLE_WIDGETS_OPENED, callback: this.handleVisitorFocusChanged});
            } else {
                if (this.visitorId) {
                    var participantPath = lpTag.WebAgent.logicController.getParticipantPath(this.visitorId);
                    this.bindModel({modelPath: participantPath + ".participantTag", callback: this.participantTagChanged});
                    this.bindEvents(this.visitorId);
                }
            }
        },

        render: function () {
        }
    });

    PageNavigationWidget.prototype.getPagesConfig = function (visitorId) {
        var result = {};
        result.pagesPath = this.getPagesModelPath(visitorId);
        return result;
    };

    PageNavigationWidget.prototype.getPagesModelPath = function (visitorId) {
        var participantDataPath;
        if (visitorId) {
            participantDataPath = lpTag.WebAgent.logicController.getParticipantDataPath(visitorId);
            return participantDataPath + ".data.pages";
        }
    };

    PageNavigationWidget.prototype.unBindEvents = function (visitorId) {
        var pagesConfig;
        if (visitorId) {
            pagesConfig = this.getPagesConfig(visitorId);
            this.unbindModel({modelPath: pagesConfig.pagesPath, callback: this.visitorDataPagesChanged});
        }
    };

    PageNavigationWidget.prototype.bindEvents = function (visitorId) {
        var pagesConfig;
        if (visitorId) {
            pagesConfig = this.getPagesConfig(visitorId);
            this.bindModel({modelPath: pagesConfig.pagesPath, callback: this.visitorDataPagesChanged});
        }
    };


    PageNavigationWidget.prototype.handleVisitorFocusChanged = function (data) {
        if (!data.newValue || !data.newValue.eventData) {
            return;
        }
        var id = data.newValue.eventData.id;

        this.unBindEvents(this.visitorId);
        this.visitorId = id;
        this.bindEvents(this.visitorId);
        //we invoke visitorDataPagesChanged with eventData for  cases that participants.info not exists yet
        this.visitorDataPagesChanged(data.newValue.eventData.pages);
    };

    PageNavigationWidget.prototype.visitorDataPagesChanged = function (data) {
        var pages = data && data.newValue || data;
        if (!pages || pages.constructor !== Array) {
            pages = [];
        }
        this.showOrHideWidget(pages);
        this.pageNavigationTable.updateModelData(pages);
    };

    PageNavigationWidget.prototype.pageNavigationDataRenderer = {
        numberOfRowsInSection: function (data) {
            return data.length;
        },

        dataForRowInSection: function (data, rowIndex) {
            var rowData = data[rowIndex];
            var value = this.createLinkForInfoItem(rowData);
            value.rowData = rowData;
            switch (rowIndex) {
                case 0 :
                    value.text = this.translate("VisitorInfoViewController_currentPage"); break;
                case 1 :
                    value.text = this.translate("VisitorInfoViewController_previousPages"); break;
                default :
                    break;
            }

            // toggle show/hide of sections container
            // using empty string as fallback to guard from translation in the template of undefined value
            value.hideSectionsClassName = value.sections ? "" : "hidden";

            return value;
        }
    };

    PageNavigationWidget.prototype.createLinkForInfoItem = function (data) {
        var linkForInfoItem = {};

        linkForInfoItem.sections = data.sections || "";
        linkForInfoItem.title = data.title || "";
        linkForInfoItem.url = data.url || "";
        linkForInfoItem.time = data.startTime;

        if (!linkForInfoItem.title) {
            linkForInfoItem.title = this.translate("pageHasNoTitle");
        }
        if (linkForInfoItem.time) {
            linkForInfoItem.time = this.formatTime(linkForInfoItem.time, false);
        }

        linkForInfoItem.href = linkForInfoItem.url;

        return linkForInfoItem;
    };

    PageNavigationWidget.prototype.participantTagChanged = function (data) {
        if (!data.newValue) {
            return;
        }
        if (this.color) {
            this.removeClass(this.LPViewMap.pageNavigationTable, this.color);
        }
        this.color = data.newValue;
        this.addClass(this.LPViewMap.pageNavigationTable, this.color);
    };

    PageNavigationWidget.prototype.showOrHideWidget = function (pages) {
        this.hidden = !pages || !pages.length;
        this.showWidget();
    };

    return PageNavigationWidget;

});
